module.exports = __webpack_public_path__ + "img/box4-img2.2c569973.png";